/* globals Router */

/**
 * @param {Router.Route} config
 * @returns {Router.Route}
 */
export const makeRoute = config => ({
	controllerAs: '$ctrl',
	resolveAs: '$resolve',
	...config,
});
